import React from 'react';
import ReactDOM from 'react-dom/client';

// FIX 1: The component you copied from the chat history is a .jsx file, so we explicitly import .jsx
import App from './App.jsx';

// FIX 2: reportWebVitals is typically a .js file in CRA, so we add the .js extension
import reportWebVitals from './reportWebVitals.js';

// If you added Tailwind CSS using the global index.css file, ensure it's imported here:
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you kept the reportWebVitals.js file:
reportWebVitals();